import React, { useEffect, useState } from 'react'
import _, { isEmpty } from 'lodash'
import crossIconGray from "../../../assets/images/cross-icon-gray.svg";
import replaceDocIcon from "../../../assets/images/replaceDocIcon.svg";
import uploadImage from "../../../assets/images/Group.svg";
import IsLoadingHOC from '../../HOC/loader/IsLoadingHOC';
import { addKycDetail, getEntityDetails, getKycDetails, updateKyc, updateKycDetail } from '../../../services';
import { useToast } from '../../../toast';
import { useSelector } from 'react-redux';
import backArrow from "../../../assets/images/left-arrow.svg";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { REGISTER_DETAILS } from '../../../redux/action_type';

const kycSchema = yup.object({
  panNumber: yup.string()
    .required("PAN number cannot be empty"),
  // .matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, "Invalid PAN number"),
  adhaarNumber: yup.string()
    .matches(/[0-9]{12}/, "Invalid Adhaar number"),
});


const KycInfo = ({ setLoading }) => {
  const toast = useToast();
  const profileDetails = useSelector((state) => state.profileDetails)
  let authData = localStorage.getItem(REGISTER_DETAILS)
  authData = JSON.parse(authData)
  const [filePanUpload, setFilePanUpload] = useState([])
  const [fileData, setFileData] = useState({})
  const [previewPan, setPreviewPan] = useState(null);
  const [SubmitValue, setSubmitValue] = useState("")
  const [removedFileIdPan, setRemovedFileIdPan] = useState([])
  const [fileValidationMbPan, setFileValidationMbPan] = useState(false)
  const [fileAdhaarUploadFront, setFileAadhaarUploadFront] = useState([])
  const [fileValidationMbAdhaarFront, setFileValidationMbAdhaarFront] = useState(false)
  const [removedAadhaarFront, setRemovedAadhaarFront] = useState([])
  const [fileAdhaarUploadBack, setFileAadhaarUploadBack] = useState([])
  const [fileValidationMbAdhaarBack, setFileValidationMbAdhaarBack] = useState(false)
  const [removedAadhaarBack, setRemovedAadhaarBack] = useState([])
  const [fileUploadValidationPan, setFileUploadValidationPan] = useState(false)
  const [fileUploadValidationAadharFront, setFileUploadValidationAadharFront] = useState(false)
  const [fileUploadValidationAadharBack, setFileUploadValidationAadharBack] = useState(false)
  const [previewAdhaarFront, setPreviewAdhaarFront] = useState(null);
  const [previewAdhaarBack, setPreviewAdhaarBack] = useState(null);
  const [iframeMouseOver, setIframeMouseOver] = useState(false)
  const [pdfViewerData, setPdfViewerData] = useState("")
  const [bankStatus, setBankStatus] = useState(false)
  const [fileChequeUpload, setFileChequeUpload] = useState([])
  const [previewCheque, setPreviewCheque] = useState(null);
  const [removedFileIdCheque, setRemovedFileIdCheque] = useState([])
  const [fileUploadValidationCheque, setFileUploadValidationCheque] = useState(false)
  const [fileValidationMbCheque, setFileValidationMbCheque] = useState(false)
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false)
  const [iframeMouseOverCheque, setIframeMouseOverCheque] = useState(false)
  const [iframeMouseOverAdhaarFr, setIframeMouseOverAdhaarFr] = useState(false)
  const [iframeMouseOverAdhaarBk, setIframeMouseOverAdhaarBk] = useState(false)
  const [initializeValue, setInitializeValue] = useState([])
  const [updateDetails, setUpdateDetails] = useState(false)
  const [entityType, setEntityType] = useState("")
  const [email, setEmail] = useState("")
  var adhaarRegex = /[0-9]{12}/
  var panRegex = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/i;
  const removingChars = ["e", "E", "-"];

  const {
    register,
    handleSubmit,
    control: control,
    reset,
    setValue,
    getValues,
    watch,
    trigger,
    clearErrors,
    formState: { errors, isDirty, dirtyFields },
  } = useForm({ mode: "onChange", resolver: yupResolver(kycSchema) });
  watch('panNumber')
  watch('adhaarNumber')

  useEffect(() => {

    // if (props.valueInitialise === 'entity') {
    getKycDetails(authData?.josh_user_id).then((res) => {
      // getEntityDetails("kaur.gurpreet@techugo.com").then((res) => {
      var response = res.data
      if (isEmpty(response)) {
        setUpdateDetails(false)
        // setValueInitialise("")
      } else {
        setUpdateDetails(true)
        setInitializeValue(response)
        setEmail(response?.email || "")
        setFilePanUpload(response?.pancard_image)
        setPreviewPan(response?.pancard_image)
        setPreviewCheque(response?.cheque_file)
        // $('#hiddenPan').val("1234")
        // setValue('hiddenPan', "")
        setPreviewAdhaarBack(response?.aadhaar_card_back_image)
        setPreviewAdhaarFront(response?.aadhaar_card_image)
        setFileAadhaarUploadFront(response?.aadhaar_card_image || [])
        setFileAadhaarUploadBack(response?.aadhaar_card_back_image || [])
        setFileChequeUpload(response?.cheque_file)
        setEntityType(response?.entity_type === '1' ? 'Creator' : (response?.entity_type === '2' ? 'Vendor' : 'Agency'))
        setValue('panNumber', response?.pancard_no || "")
        setValue('adhaarNumber', response?.aadhaar_no || "")
      }
    }
    )
    // }

  }, [])

  const handlePanFileChange = (e) => {
    setFileUploadValidationPan(false);
    if (Object.values(e?.target?.files)?.length === 1) {
      if (e?.target?.files[0]?.size > 6e6) {
        setFileValidationMbPan(true);
        e.preventDefault();
        return;
      } else {
        setFileValidationMbPan(false);
      }
      setFilePanUpload(Object.values(e?.target?.files));
    } else {
      e.preventDefault();
    }
    if (
      e?.target?.files[0]?.name?.includes(".pdf") ||
      filePanUpload?.includes(".pdf")
    ) {
      if (!isEmpty(e?.target?.files[0]?.name)) {
        const url = URL.createObjectURL(e?.target?.files[0]);
        setPreviewPan(url);
      } else {
        setPreviewPan(e?.target?.files[0]);
      }
    } else {
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        setPreviewPan(fileReader.result);
      });
      fileReader.readAsDataURL(file);
    }
  };

  const handleAdhaarFileChangeFront = (e) => {
    setFileUploadValidationAadharFront(false);
    if (Object.values(e?.target?.files)?.length === 1) {
      if (e?.target?.files[0]?.size > 6e6) {
        setFileValidationMbAdhaarFront(true);
        e.preventDefault();
        return;
      } else {
        setFileValidationMbAdhaarFront(false);
      }
      setFileAadhaarUploadFront(Object.values(e?.target?.files));
    } else {
      e.preventDefault();
    }
    if (
      e?.target?.files[0]?.name?.includes(".pdf") ||
      filePanUpload?.includes(".pdf")
    ) {
      if (!isEmpty(e?.target?.files[0]?.name)) {
        const url = URL.createObjectURL(e?.target?.files[0]);
        setPreviewAdhaarFront(url);
      } else {
        setPreviewAdhaarFront(e?.target?.files[0]);
      }
    } else {
      const file = e?.target?.files[0];
      const fileReader = new FileReader();
      fileReader?.addEventListener("load", () => {
        setPreviewAdhaarFront(fileReader.result);
      });
      fileReader.readAsDataURL(file);
    }
  };

  const handleAdhaarFileChangeBack = (e) => {
    setFileUploadValidationAadharBack(false);
    if (Object.values(e?.target?.files)?.length === 1) {
      if (e?.target?.files[0]?.size > 6e6) {
        setFileValidationMbAdhaarBack(true);
        e.preventDefault();
        return;
      } else {
        setFileValidationMbAdhaarBack(false);
      }
      setFileAadhaarUploadBack(Object.values(e?.target?.files));
    } else {
      e.preventDefault();
    }
    if (
      e?.target?.files[0]?.name?.includes(".pdf") ||
      filePanUpload?.includes(".pdf")
    ) {
      if (!isEmpty(e?.target?.files[0]?.name)) {
        const url = URL.createObjectURL(e?.target?.files[0]);
        setPreviewAdhaarBack(url);
      } else {
        setPreviewAdhaarBack(e?.target?.files[0]);
      }
    } else {
      const file = e?.target?.files[0];
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        setPreviewAdhaarBack(fileReader.result);
      });
      fileReader.readAsDataURL(file);
    }
  };

  const handleFileChangeCheque = (e) => {
    setFileUploadValidationCheque(false);
    if (Object.values(e?.target?.files)?.length === 1) {
      if (e.target.files[0].size > 6e6) {
        setFileValidationMbCheque(true);
        e.preventDefault();
        return;
      } else {
        setFileValidationMbCheque(false);
      }
      setFileChequeUpload(Object.values(e?.target?.files));
    } else {
      e.preventDefault();
    }
    if (
      e?.target?.files[0]?.name?.includes(".pdf") ||
      filePanUpload?.includes(".pdf")
    ) {
      if (!isEmpty(e?.target?.files[0]?.name)) {
        const url = URL.createObjectURL(e?.target?.files[0]);
        setPreviewCheque(url);
      } else {
        setPreviewCheque(e?.target?.files[0]);
      }
    } else {
      const file = e.target.files[0];
      const fileReader = new FileReader();
      fileReader?.addEventListener("load", () => {
        setPreviewCheque(fileReader.result);
      });
      fileReader.readAsDataURL(file);
    }
  };

  const removeFilePan = (data) => {
    if (typeof data === "number") {
      setRemovedFileIdPan([...removedFileIdPan, data]);
      setFilePanUpload(filePanUpload?.filter((e) => e?.id !== data));
    } else {
      setFilePanUpload([]);
    }
  };
  const removeFileAdhaarFront = (data) => {
    if (typeof data === "number") {
      setRemovedAadhaarFront([...removedAadhaarFront, data]);
      setFileAadhaarUploadFront(
        fileAdhaarUploadFront?.filter((e) => e?.id !== data)
      );
    } else {
      setFileAadhaarUploadFront([]);
    }
  };

  const pdfViewer = (data, signState) => {
    if (!isEmpty(data.name)) {
      const url = URL.createObjectURL(data);
      setPdfViewerData(url);
    } else {
      setPdfViewerData(data);
    }
    setFileData(data);
    setIsDocumentModalOpen(true);
  };

  const removeFileAdhaarBack = (data) => {
    if (typeof data === "number") {
      setRemovedAadhaarBack([...removedAadhaarBack, data]);
      setFileAadhaarUploadBack(
        fileAdhaarUploadBack?.filter((e) => e?.id !== data)
      );
    } else {
      setFileAadhaarUploadBack([]);
    }
  };
  const removeFileCheque = (data) => {
    if (typeof data === "number") {
      setRemovedFileIdCheque([...removedFileIdCheque, data]);
      setFileChequeUpload(fileChequeUpload?.filter((e) => e?.id !== data));
    } else {
      setFileChequeUpload([]);
    }
  };

  const handleApiData = (formData, value, type) => {
    setLoading(true);
    if (updateDetails === true) {
      updateKycDetail(formData)
        .then((res) => {
          if (res.status) {
            setLoading(false);
            setFileValidationMbPan(false);
            setFileValidationMbCheque(false);
            setFileValidationMbAdhaarBack(false);
            setFileValidationMbAdhaarFront(false);
            setFileData({});
            setFileUploadValidationPan(false);
            setFileUploadValidationCheque(false);
            setSubmitValue("");
            toast.open(res?.message || "KYC Updated successfully");
          } else if (res?.statusCode === 201) {
            setLoading(false);
            toast.open(`${res.message}`, "error");
          } else {
            setLoading(false);
            toast.open(`${res.message}`, "error");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.open(error?.message);
        });
    } else {
      addKycDetail(formData)
        .then((res) => {
          if (res.status) {
            setLoading(false);
            setFileValidationMbPan(false);
            setFileValidationMbCheque(false);
            setFileValidationMbAdhaarBack(false);
            setFileValidationMbAdhaarFront(false);
            setFileData({});
            setFileUploadValidationPan(false);
            setFileUploadValidationCheque(false);
            setSubmitValue("");
            toast.open(res?.message || "KYC Added successfully");
          } else if (res?.statusCode === 201) {
            setLoading(false);
            toast.open(`${res.message}`, "error");
          } else {
            setLoading(false);
            toast.open(`${res.message}`, "error");
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.open(error?.message);
        });
    }
  };

  const onSubmit = handleSubmit((values, type) => {
    let formData = new FormData();
    formData.append("pancard_no", values?.panNumber);
    formData.append("aadhaar_no", values?.adhaarNumber);
    formData.append("josh_user_id", authData?.josh_user_id)
    if(updateDetails===true){
      formData.append("id", initializeValue?.id)
    }
    if ((isEmpty(filePanUpload))) {
      if (isEmpty(filePanUpload)) {
        setFileUploadValidationPan(true)
      }
    }
    if ((isEmpty(fileAdhaarUploadFront))) {
      if (isEmpty(fileAdhaarUploadFront)) {
        setFileUploadValidationAadharFront(true)
      }
    }
    if ((isEmpty(fileAdhaarUploadBack))) {
      if (isEmpty(fileAdhaarUploadBack)) {
        setFileUploadValidationAadharBack(true)
      }
    }
    if ((isEmpty(fileChequeUpload))) {
      if (isEmpty(fileChequeUpload)) {
        setFileUploadValidationCheque(true)
      }
    }

    if (filePanUpload?.length === 1) {
      formData.append("pancard", filePanUpload?.[0]);
    } else if (isEmpty(filePanUpload)) {
      setFileUploadValidationPan(true)
      formData.append("is_removed_pancard", "1");
    }
    if (fileAdhaarUploadFront?.length === 1) {
      formData.append("aadhaar_card", fileAdhaarUploadFront?.[0]);
    } else if (isEmpty(fileAdhaarUploadFront)) {
      formData.append("is_removed_aadhaarcard", "1");
    }
    if (fileAdhaarUploadBack?.length === 1) {
      formData.append("aadhaar_card_back", fileAdhaarUploadBack?.[0]);

    } else if (isEmpty(fileAdhaarUploadBack)) {
      formData.append("is_removed_aadhaarcard_back", "1");
    }
    if (fileChequeUpload?.length === 1) {
      formData.append("cheque_file", fileChequeUpload?.[0]);

    } else if (isEmpty(fileChequeUpload)) {
      formData.append("is_removed_cheque", "1");
    }

    if (!isEmpty(filePanUpload) && !isEmpty(fileAdhaarUploadFront) && !isEmpty(fileAdhaarUploadBack) && !isEmpty(fileChequeUpload)) {
      handleApiData(formData)
    }

  });

  return (
    // <div className="mobile-responsive-bar">
    //     <div className="mobile-header-wrap d-block d-md-none d-flex mob-header">
    // <div>KycInfo</div>
    // </div>
    <div className="affiliate-dashboard kyc-form-wrap">
      <div className="kyc-header">
        <img src={backArrow} style={{ cursor: "pointer" }} onClick={() => window.open("https://stage-creatorpro.myjosh.in/affiliate_store/wallet?d_type=web", "_self")} /> <span>Add KYC Details</span>
      </div>
      <form onSubmit={onSubmit}>
        <div className="row">
          {/* PAN Card Uploader Sec Start Here */}
          <div className="col-md-12">
            <div className="form-group upload-inputs">
              <label>PAN Card Number<span className="requiredColor">*</span></label>
              <input className={(!panRegex.test(getValues('panNumber')) && (getValues('panNumber')?.length > 0)) ? "form-control errorInput" : "form-control"} placeholder="Enter here"
                // disabled={editableDetails}
                name="panNumber"
                {...register("panNumber", { required: true })}
                onKeyDown={event => {
                  if (event.which === 8 || event.keyCode == 46) {
                    return true
                  } else if (event.target.value.length > 9 || ["-"]?.includes(event.key)) {
                    event.preventDefault();
                  }
                }}
                autoComplete="off"
              />
              {(!panRegex.test(getValues('panNumber')) && (getValues('panNumber')?.length > 0)) ? (
                <div className="error" style={{fontSize:"14px"}}>
                  {"Invalid PAN number"}
                </div>
              ) : null}
            </div>

            <div className="file-uploder-wrap">
              <div className="form-group">
                <label htmlFor="">
                  Upload PAN <span className="requiredColor">*</span>
                </label>
                {!isEmpty(filePanUpload) ? (
                  <div className="uploaded-document-wrap uploaded-new-wrap">
                    <div className="uploaded-document">
                      <div className="uploaded-card">
                        {/* <img
                          className="close-view-doc"
                          src={crossIconGray}
                          alt=""
                          onClick={() =>
                            removeFilePan(filePanUpload.name || filePanUpload)
                          }
                        /> */}
                        {filePanUpload
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes("jpg") ||
                          filePanUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jpg") ||
                          filePanUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("jpeg") ||
                          filePanUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jpeg") ||
                          filePanUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("png") ||
                          filePanUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("png") ||
                          filePanUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("jfif") ||
                          filePanUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jfif") ? (
                          <img
                            src={previewPan}
                            className="preview-uploaded-img"
                            alt="preview-image"
                            height="50px"
                            width="100px"
                            onClick={() =>
                              pdfViewer(
                                Array.isArray(filePanUpload)
                                  ? filePanUpload?.[0]
                                  : filePanUpload
                              )
                            }
                          />
                        ) : (
                          <div
                            onMouseOver={() => setIframeMouseOver(true)}
                            onMouseOut={() => {
                              window.focus();
                              setIframeMouseOver(false);
                            }}
                          >
                            <iframe
                              className="preview-uploaded-img"
                              width="300"
                              height="50"
                              src={previewPan}
                            >
                              {" "}
                            </iframe>{" "}
                          </div>
                        )}
                        {/* <p onClick={() => pdfViewer(filePanUpload)}>{filePanUpload?.[0].name || filePanUpload?.toString()?.split("pancard/")?.[1]}</p> */}
                      </div>
                    </div>
                    <input
                      type="file"
                      id="filePan"
                      name="filePan"
                      onChange={handlePanFileChange}
                      accept="image/jpg,image/png,image/jpeg,.pdf"
                    />
                    {(filePanUpload?.length === 1 ||
                      filePanUpload?.includes("pancard/")) && (
                        <label htmlFor="filePan">
                          <img src={replaceDocIcon} alt="" /> Replace document
                        </label>
                      )}
                  </div>
                ) : (
                  <div
                    className={
                      fileValidationMbPan ||
                        (fileUploadValidationPan && SubmitValue === true)
                        ? "dropzone errorInputFile"
                        : "dropzone"
                    }
                  >
                    <img src={uploadImage} />
                    <input
                      type="file"
                      id="filePan"
                      name="filePan"
                      onChange={handlePanFileChange}
                      accept="image/jpg,image/png,image/jpeg,.pdf"
                    />
                    <span>
                      <a href="javascript:void(0);">Upload PAN Card*</a>
                    </span>
                    <span className="file-instructions">
                      File must be 6 MB or smaller and in PDF format
                    </span>
                  </div>
                )}
                {fileValidationMbPan ? (
                  <div className="error" style={{fontSize:"14px"}}>{"Maximum size allowed is 6MB"}</div>
                ) : fileUploadValidationPan === true ? (
                  <div className="error" style={{fontSize:"14px"}}>
                    {"You need to provide at least one document"}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/* PAN Card Uploader Sec End Here */}
          {/* Aadhaar Card Uploader Sec Start Here */}
          <div className="col-md-12">
            <div className="form-group upload-inputs">
              <label>Aadhaar Card Number <span className="requiredColor"> *</span></label>
              <input className={(!adhaarRegex.test(getValues('adhaarNumber')) && getValues('adhaarNumber')?.length > 0) ? "form-control errorInput" : "form-control"} placeholder="Enter here"
                // type="number"
                name="adhaarNumber"
                // disabled={editableDetails}
                {...register("adhaarNumber", { required: true })}
                onKeyDown={event => {
                  if (event?.which === 8 || event.keyCode == 46) {
                    return true
                  } else if (event?.target.value.length > 11 || removingChars?.includes(event.key)) {
                    event.preventDefault();
                  }
                }}
                autoComplete="off"
              // disabled
              />
              {(!adhaarRegex.test(getValues('adhaarNumber')) && getValues('adhaarNumber')?.length > 0) ? (
                <div className="error" style={{fontSize:"14px"}}>
                  {"Invalid Adhaar Number"}
                </div>
              ) : null}
            </div>
            <div className="file-uploder-wrap">
              <div className="form-group">
                <label htmlFor="">
                  Upload Aadhaar <span className="requiredColor"> *</span>
                </label>
                <div
                  className={
                    (fileValidationMbAdhaarBack || fileValidationMbAdhaarFront) &&
                      SubmitValue === true
                      ? "id-proof-wrap errorInputFile"
                      : "id-proof-wrap"
                  }
                >
                  <div className="id-proof">
                    {!isEmpty(fileAdhaarUploadFront) ? (
                      <div className="uploaded-document-wrap">
                        <div className="uploaded-document common-scroll-page">
                          <div className="uploaded-card">
                            {/* <img
                              className="close-view-doc"
                              src={crossIconGray}
                              alt=""
                              onClick={() =>
                                removeFileAdhaarFront(
                                  fileAdhaarUploadFront.name ||
                                  fileAdhaarUploadFront
                                )
                              }
                            /> */}
                            {fileAdhaarUploadFront
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes("jpg") ||
                              fileAdhaarUploadFront?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jpg") ||
                              fileAdhaarUploadFront
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("jpeg") ||
                              fileAdhaarUploadFront?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jpeg") ||
                              fileAdhaarUploadFront?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("png") ||
                              fileAdhaarUploadFront
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("png") ||
                              fileAdhaarUploadFront
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("jfif") ||
                              fileAdhaarUploadFront?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jfif") ? (
                              <img
                                src={previewAdhaarFront}
                                alt="preview-image"
                                height="50px"
                                width="100px"
                                className="preview-uploaded-img"
                                onClick={() =>
                                  pdfViewer(
                                    Array.isArray(fileAdhaarUploadFront)
                                      ? fileAdhaarUploadFront?.[0]
                                      : fileAdhaarUploadFront
                                  )
                                }
                              />
                            ) : (
                              <div
                                onMouseOver={() =>
                                  setIframeMouseOverAdhaarFr(true)
                                }
                                onMouseOut={() => {
                                  window.focus();
                                  setIframeMouseOverAdhaarFr(false);
                                }}
                              >
                                {" "}
                                <iframe
                                  className="preview-uploaded-img"
                                  width="100"
                                  height="50"
                                  src={previewAdhaarFront}
                                  id="adhaarFrontPreviewId"
                                />
                              </div>
                            )}
                            {/* <p onClick={() => pdfViewer(fileAdhaarUploadFront)}>{fileAdhaarUploadFront?.[0].name || fileAdhaarUploadFront?.toString()?.split("aadhaar-card/")?.[1]}</p> */}
                          </div>
                        </div>
                        <input
                          type="file"
                          id="fileAdharFront"
                          name="fileAdharFront"
                          onChange={handleAdhaarFileChangeFront}
                          accept="image/jpg,image/png,image/jpeg,.pdf"
                          multiple
                        />
                        {(fileAdhaarUploadFront?.length === 1 ||
                          fileAdhaarUploadFront?.includes("aadhaar-card")) && (
                            <label htmlFor="fileAdharFront">
                              <img src={replaceDocIcon} alt="" /> Replace document
                            </label>
                          )}
                      </div>
                    ) : (
                      <div className={"dropzone"}>
                        <img src={uploadImage} />
                        <input
                          type="file"
                          id="fileAdharFront"
                          name="fileAdharFront"
                          onChange={handleAdhaarFileChangeFront}
                          accept="image/jpg,image/png,image/jpeg,.pdf"
                        />
                        <span>
                          <a href="javascript:void(0);">front side </a>
                        </span>
                      </div>
                    )}
                    {/* {fileValidationMbAdhaarFront ? (
                    <div className="error">{"Maximum size allowed is 6MB"}</div>
                  ) : fileUploadValidationAadharFront === true ? (
                    <div className="error">
                      {"You need to provide at least one document"}
                    </div>
                  ) : null} */}
                    <div className="divder-wrap"></div>
                    {!isEmpty(fileAdhaarUploadBack) ? (
                      <div className="uploaded-document-wrap">
                        <div className="uploaded-document">
                          <div className="uploaded-card">
                            {/* <img
                              className="close-view-doc"
                              src={crossIconGray}
                              alt=""
                              onClick={() =>
                                removeFileAdhaarBack(
                                  fileAdhaarUploadBack.name ||
                                  fileAdhaarUploadBack
                                )
                              }
                            /> */}
                            {fileAdhaarUploadBack
                              ?.toString()
                              ?.toLowerCase()
                              ?.includes("jpg") ||
                              fileAdhaarUploadBack?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jpg") ||
                              fileAdhaarUploadBack
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("jpeg") ||
                              fileAdhaarUploadBack?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jpeg") ||
                              fileAdhaarUploadBack
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("png") ||
                              fileAdhaarUploadBack?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("png") ||
                              fileAdhaarUploadBack
                                ?.toString()
                                ?.toLowerCase()
                                ?.includes("jfif") ||
                              fileAdhaarUploadBack?.[0]?.name
                                ?.toLowerCase()
                                ?.includes("jfif") ? (
                              <img
                                src={previewAdhaarBack}
                                className="preview-uploaded-img"
                                alt="preview-image"
                                height="50px"
                                width="100px"
                                onClick={() =>
                                  pdfViewer(
                                    Array.isArray(fileAdhaarUploadBack)
                                      ? fileAdhaarUploadBack?.[0]
                                      : fileAdhaarUploadBack
                                  )
                                }
                              />
                            ) : (
                              <div
                                onMouseOver={() =>
                                  setIframeMouseOverAdhaarBk(true)
                                }
                                onMouseOut={() => {
                                  window.focus();
                                  setIframeMouseOverAdhaarBk(false);
                                }}
                              >
                                {" "}
                                <iframe
                                  className="preview-uploaded-img"
                                  width="300"
                                  height="50"
                                  src={previewAdhaarBack}
                                  id="adhaarBackPreviewId"
                                ></iframe>
                              </div>
                            )}
                            {/* <p onClick={() => pdfViewer(fileAdhaarUploadBack)}>{fileAdhaarUploadBack?.[0].name || fileAdhaarUploadBack?.toString()?.split("aadhaar-card/")?.[1]}</p> */}
                          </div>
                        </div>
                        <input
                          type="file"
                          id="fileAdharBack"
                          name="fileAdharBack"
                          onChange={handleAdhaarFileChangeBack}
                          accept="image/jpg,image/png,image/jpeg,.pdf"
                          multiple
                        />
                        {(fileAdhaarUploadBack?.length === 1 || initializeValue?.status != "0" ||
                          fileAdhaarUploadBack?.includes("aadhaar-card")) && (
                            <label htmlFor="fileAdharBack">
                              <img src={replaceDocIcon} alt="" /> Replace document
                            </label>
                          )}
                      </div>
                    ) : (
                      <div className={"dropzone"}>
                        <img src={uploadImage} />
                        <input
                          type="file"
                          id="fileAdharBack"
                          name="fileAdharBack"
                          onChange={handleAdhaarFileChangeBack}
                          accept="image/jpg,image/png,image/jpeg,.pdf"
                        />
                        <span>
                          <a href="javascript:void(0);">Back Side</a>
                        </span>
                      </div>
                    )}
                  </div>
                  {fileAdhaarUploadFront?.length < 1 &&
                    fileAdhaarUploadBack?.length < 1 ? (
                    <span className="file-instructions">
                      File must be 6 MB or smaller and in PDF format
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                {fileValidationMbAdhaarBack || fileValidationMbAdhaarFront ? (
                  <div className="error" style={{fontSize:"14px"}}>{"Maximum size allowed is 6MB"}</div>
                ) : fileUploadValidationAadharBack === true || fileUploadValidationAadharFront === true ? (
                  <div className="error" style={{fontSize:"14px"}}>{"You need to provide at least one document"}</div>
                ) : null}



                <div className="max-file-errors">
                  {
                    // ((fileUploadValidationAdhaarFront === true || fileUploadValidationAdhaarBack === true) && SubmitValue === true) ? (
                    //   <div className="error">
                    //     {"You need to provide at least one document"}
                    //   </div>
                    // )
                    //   :
                    fileValidationMbAdhaarFront ? (
                      <div className="error" style={{fontSize:"14px"}}>{"Maximum size allowed is 6MB"}</div>
                    ) : null
                  }
                  {
                    // (fileUploadValidationAdhaarBack===true && SubmitValue===true) ? (
                    //   <div className="error">
                    //   {"You need to provide at least one document"}
                    // </div>
                    // ) :
                    fileValidationMbAdhaarBack ? (
                      <div className="error" style={{fontSize:"14px"}}>{"Maximum size allowed is 6MB"}</div>
                    ) : null
                  }
                </div>
              </div>
            </div>
          </div>
          {/* Aadhaar Card Uploader Sec End Here */}
          {/* Cancelled Cheque Sec Start Here */}
          <div className="col-md-12">
            <div className="file-uploder-wrap">
              <div className="form-group">
                <label htmlFor="" className={bankStatus && "hideLabel"}>
                  Upload Cancelled Cheque{" "}
                  <span className="requiredColor"> *</span>
                </label>
                {!isEmpty(fileChequeUpload) ? (
                  <div className="uploaded-document-wrap uploaded-new-wrap">
                    <div
                      className={
                        bankStatus
                          ? "uploaded-document common-scroll-page disabledCheque"
                          : "uploaded-document common-scroll-page"
                      }
                    >
                      <div className="uploaded-card">
                        {/* <img
                          className="close-view-doc"
                          src={crossIconGray}
                          alt=""
                          onClick={() =>
                            removeFileCheque(
                              fileChequeUpload?.name || fileChequeUpload
                            )
                          }
                        /> */}
                        {fileChequeUpload
                          ?.toString()
                          ?.toLowerCase()
                          ?.includes("jpg") ||
                          fileChequeUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jpg") ||
                          fileChequeUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("jpeg") ||
                          fileChequeUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jpeg") ||
                          fileChequeUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("png") ||
                          fileChequeUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("png") ||
                          fileChequeUpload
                            ?.toString()
                            ?.toLowerCase()
                            ?.includes("jfif") ||
                          fileChequeUpload?.[0]?.name
                            ?.toLowerCase()
                            ?.includes("jfif") ? (
                          <img
                            src={previewCheque}
                            className="preview-uploaded-img"
                            alt="preview-image"
                            height="50px"
                            width="100px"
                            onClick={() =>
                              pdfViewer(
                                Array.isArray(fileChequeUpload)
                                  ? fileChequeUpload?.[0]
                                  : fileChequeUpload
                              )
                            }
                          />
                        ) : (
                          <div
                            onMouseOver={() => setIframeMouseOverCheque(true)}
                            onMouseOut={() => {
                              window.focus();
                              setIframeMouseOverCheque(false);
                            }}
                          >
                            <iframe
                              className="preview-uploaded-img"
                              width="300"
                              height="50"
                              src={previewCheque}
                              id={"chequePreviewId"}
                            ></iframe>
                          </div>
                        )}
                        {/* <p onClick={() => pdfViewer(fileChequeUpload)}>{fileChequeUpload?.[0].name || fileChequeUpload?.toString()?.split("cancelled-cheque/")?.[1]}</p> */}
                      </div>
                    </div>
                    <input
                      type="file"
                      id="file"
                      name="fileCheque"
                      onChange={handleFileChangeCheque}
                      accept="image/jpg,image/png,image/jpeg,.pdf"
                    />
                    {(fileChequeUpload?.length === 1 ||
                      fileChequeUpload?.includes("cancelled-cheque/")) && (
                        <label htmlFor="filePan">
                          <img src={replaceDocIcon} alt="" /> Replace document
                        </label>
                      )}
                  </div>
                ) : (
                  <div
                    className={
                      fileValidationMbCheque ||
                        (fileUploadValidationCheque && SubmitValue === true)
                        ? "dropzone errorInputFile"
                        : "dropzone"
                    }
                  >
                    <img src={uploadImage} />
                    <input
                      type="file"
                      id="file"
                      name="fileCheque"
                      onChange={handleFileChangeCheque}
                      accept="image/jpg,image/png,image/jpeg,.pdf"
                    />
                    <span>
                      <a href="javascript:void(0);">Upload Canceled Cheque</a>
                    </span>
                    <span className="file-instructions">
                      File must be 6 MB or smaller and in PDF format
                    </span>
                  </div>
                )}
                {fileValidationMbCheque ? (
                  <div className="error" style={{fontSize:"14px"}}>{"Maximum size allowed is 6MB"}</div>
                ) : fileUploadValidationCheque === true ? (
                  <div className="error" style={{fontSize:"14px"}}>
                    {"You need to provide at least one document"}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {/*  Cancelled Cheque Sec End Here */}
        </div>
        {/* {initializeValue?.status === "0" && */}
        <div className="common-btn">
          <button className="btn-green" type="submit" >
            {/* <button className={initializeValue?.status === "0"?"btn-disable":"btn-green"} type="submit"  disabled={initializeValue?.status === "0"?true:false}> */}
            Submit
          </button>
        </div>
        {/* } */}

      </form>
    </div>
    // </div>
  );
};

export default IsLoadingHOC(KycInfo);
